import extend from 'extend'
let Const = {
    Result: {
        Success: 0,
        InvalidParam: 2,
        NoData: 3,
        Offline: 4
    },
    User: {
        AuditStatus: {
            Init: 0,
            Auditing: 1,
            Pass: 2,
            NotPass: 3
        }
    },
    Material: {
        Type: {
            Video: 1,
            Audio: 2,
            Image: 3
        },
        Status: {
            Init: -1,// 未启动
            Done: 0,
            Uploading: 1,
            Defeated: 2,
            Progress: 3,
            ProgDefeated: 4,
            OssIdle: 5,
            OssUploading: 6,
            OssDefeated: 7,
            GetInfo: 8,
            Init2: 10
        },
        VideoLevelStatus: {
            Progress: 0,
            Done: 1
        },
        PosterStatus: {
            Progress: 0,
            Done: 1
        },
        PublishStatus: {
            Init: 0,
            Defeated: 1,
            Issue: 2,
            Uploading3: 3,
            Uploading4: 4,
            Publishing: 5,
        },
        VRFlag: {
            Common: 0,
            VR: 1
        }
    },
    Watermark: {
        Type: {
            Image: 0,
            Text: 1
        },
        Position: {
            LeftTop: 1,
            LeftBottom: 2,
            RightTop: 3,
            RightBottom: 4,
            Center: 5,
            Repeat: 6
        }
    },
    liveRoom: {
        publishStatus: {
            Issue: 1,
            Close: 0
        },
        Comment: {
            Issue: 0,
            Shield: 1
        },
        VodFlag: {
            Live: 0,
            PlaybackOpen: 1,
            PlaybackClose: 2,
            Trailer: 3
        },
        RecordType: {
            UploadRecord: 0,
            LiveRecord: 1,
            transcodeRecord: 2,
            CloudEditorOutPut: 3,
            refVideo: 5,
            recordVideo: 6,
            SegmentRecord: 7,
            TimelapseRecord: 8
        },
        liveRecordTaskStatus: {
            Init: 0,
            Starting: 1,
            Recording: 3,
            Stop: 5
        },
        Status: {
            Wait: 0,
            Pushing: 1,
            Stop: 2
        },
        ThirdLiveType: {
            Pull: 0,
            Push: 1,
            File: 2,
            Director: 3,
            WhitelistPull: 4
        },
        ThirdLiveSwitch: {
            Off: 1,
            On: 0
        },
        PushFlag: {
            Normal: 0,
            Transcode: 1,
            CDN: 2
        },
    },
    LiveCategory: {
        Status: {
            Publish: 1,
            UnPublish: 0,
        }
    },
    Record: {
        PublishStatus: {
            Init: 0,
            Error: 1,
            Success: 2,
            updateVideo: 3,
            updateImage: 4,
            Push: 5,
            Pushing: 10,
        },
        // RecordStatus:  见 Const.Material.Status
    },
    Goods: {
        State: {
            Online: 0,
            Offline: 1
        }
    },
    Template: {
        Format: {
            "16:9": [1280, 720],
            "9:16": [1280, 2275],
            "4:3": [1280, 960]
        }
    },
    CloudEditor: {
        Mode: {
            Common: 0,
            VR: 1
        }
    },
    Director: {
        Mode: {
            Common: 0,
            VR: 1,
            SlowLive: 2
        }
    },
    MaterialCms: {
        Material: {
            Status: {
                Idle: 0,
                Progress: 1,
                Done: 2,
                Error: 3
            },
            PublicStatus: {
                Idle: 0,
                Progress: 1,
                Done: 2,
                Error: 3
            },
        },
    },
    LiveRoomFunction: {
        // 视频直播
        VideoLive: 1,
        // 弹幕
        Barrage: 1<<1,
        // APP下载
        AppDownload: 1<<2,
        // 相关报道
        RelatedReport: 1<<3,
        // 评论
        Chat: 1<<4,
        // 点赞
        Praise: 1<<5,
        // 直播海报
        Poster: 1<<6,
        // 图文直播
        WordLive: 1<<7,
        // 访问数
        NumberOfVisits: 1<<8,
        // 点赞数
        NumberOfPraise: 1<<9,
        // 欢迎页
        WelcomePage: 1<<10,
        // 回顾列表
        ShowRecord: 1<<11,
        // 竖屏直播(已弃用)
        VerticalScreenLiving: 1<<12,
        // 浮动气泡
        BubbleSwitch: 1<<13,
        // 直播带货
        LiveProduct: 1<<14,
        // VR直播
        VRLive: 1<<15
    },
    SelectType: {
        unselected: -1,
        my: 1,
        department: 2,
        usergroup: 3
    }
}

//添加构造函数式的 toString 方法。
//形如： Const.Result.Success(2) 返回 "Const.Result.Success.InvalidParam"
function setupToString(o, prefix) {

    let ret = i => {
        for (let k in o) {
            if (o[k] == i) {
                return prefix + "." + k;
            }
        }
    }

    ret = extend(ret, o);

    for (let key in o) {
        let item = o[key];

        if (Object.prototype.toString.call(item) == '[object Object]') {
            ret[key] = setupToString(item, prefix + "." + key)
        }

    }

    return ret;
}

Const = setupToString(Const, "Const");


//test
// console.log(Const.Material.Status(Const.Material.Status.Progress));

export default {
    Const
}

export { Const };